import { render, staticRenderFns } from "./Burst.vue?vue&type=template&id=de6e2ae4&scoped=true"
import script from "./Burst.vue?vue&type=script&lang=js"
export * from "./Burst.vue?vue&type=script&lang=js"
import style0 from "./Burst.vue?vue&type=style&index=0&id=de6e2ae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6e2ae4",
  null
  
)

export default component.exports